module.exports = __webpack_public_path__ + "a2984ce4bd6cb4d318dff6d78d1aaa0d.jpg";